import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { ContentListService } from 'src/app/shared/services/content-list.service';
import { ResolverCacheService } from 'src/app/shared/services/resolver-cache.service';
import { ContentListResponseDto } from 'src/app/shared/dtos/content-list.dto';

export const contentListResolver: ResolveFn<ContentListResponseDto | null> = () => {
  const contentListService = inject(ContentListService);
  const resolverCacheService = inject(ResolverCacheService);

  return resolverCacheService.createCachedResolver<ContentListResponseDto | null>(
    'content-list',
    () => contentListService.getContentList()
  );
};
